export const periods = [
  "All Dates",
  "Today",
  "Yesterday",
  "7 Days Ago",
  "A Month Ago",
  "A Year Ago",
];
export const user_status = ["all","active", "suspended"];
export const order_status = ["all","pending", "accepted", "completed", "declined"];
export const user_order_status = ["all","pending", "cancelled", "delivered"];
export const supplier_order_status = [
  "all",
  "declined",
  "processing",
  "dispatched",
  "delivered",
];
export const order_payment_status = ["all","paid", "unpaid"];
export const product_status = ["all","active", "inactive"];
export const transaction_status = ["all","pending", "success", "failed"];
export const user_transaction_status = ["all","success","failed"];
export const call_status = ["all","Done", "Pending"];
export const timeList = [
  "1:00",
  "2:00",
  "3:00",
  "4:00",
  "5:00",
  "6:00",
  "7:00",
  "8:00",
  "9:00",
  "10:00",
  "11:00",
  "12:00",
];
export const timeLocal = ["AM", "PM"];
export const time_out = ["2", "4", "6", "8", "10", "12", "30", "40"];
